import React from 'react';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModelDTO } from '../../api/useModelGroupsQuery';
import { isTempEntity } from '../../utils/isTempEntity';
import { UpsertModelGroupActions } from '../UpsertModelGroup/useUpsertModelGroup';
import { makeNewModel } from '../../utils/makeNewModel';

interface Props {
  model: ModelDTO;
  models: ModelDTO[];
  modelsActions: UpsertModelGroupActions;
  onClose(): void;
}

export const DeleteModel: React.FC<Props> = ({ model, models, modelsActions, onClose }) => {
  const handleDeleteModel = () => {
    if (model.id && model.portfolioName) {
      const modelIndex = models.findIndex(({ id }) => id === model.id);

      if (modelIndex > -1) {
        // In an Orion model group, the delete action for the last risk range should clear
        // the selected model instead of removing it.
        if (model.orionModelId && models.length === 1) {
          modelsActions.updateModelAt(modelIndex, makeNewModel());
        } else {
          modelsActions.removeModelAt(modelIndex);
        }
      }

      onClose();
    }
  };

  return (
    <Modal isOpen onRequestClose={onClose} size="medium" contentLabel="Delete Model">
      <ModalHeader variant="warning">Warning</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Text>Are you sure you want to delete this model?</Text>

        {!isTempEntity(model.id) && (
          <Text>Doing so will impact any client plans currently utilizing it.</Text>
        )}
      </ModalBody>

      <ModalFooter>
        <Button onClick={onClose} variant="subtleInactive" autoFocus mr="12">
          Cancel
        </Button>

        <Button variant="error" onClick={handleDeleteModel}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
